import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EsignatureDocumentView } from "./EsignatureDocumentView";
import { EsignatureDocumentViewStore } from "../../store/EsignatureDocumentViewStore";
import { useStore } from "../../../../hooks";

export const EsignatureDocumentViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/esignatureDocument/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EsignatureDocumentViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EsignatureDocumentView esignatureDocumentViewStore={store} />
      </PageLayout>
    </div>
  );
});
